var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanJumbo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hero-learning-home",
    xmlns: "http://www.w3.org/2000/svg",
    width: 850,
    height: 680,
    viewBox: "0 0 850 680",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M424.575,8.509c230.256,0,416.916,186.66,416.916,416.916H424.575Z",
    style: {
      fill: "#fbf1e2"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M127.148,319.069c42.009-22.775,95.185-7.22,129.716-20.427,42.682-19.237,111.264-22.79,141.455-5.811,0,0-.043,12.575-.4,26.238h26.652V8.509c-193.5,0-356.2,131.823-403.221,310.56Z",
    style: {
      fill: "#edf3f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.127,390.266q-1.452,17.389-1.469,35.159H45.516c16.43-4.737,37-9.376,62.772-13.552C203.471,396.449,126.2,385.482,9.127,390.266Z",
    style: {
      fill: "#8ebcbb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.007,348c-1.949-13.661,52.81-22.755,70.141-28.929H21.354a415.237,415.237,0,0,0-11.027,58.937c40.985-2.342,78.651-3.725,108.089-4.494C83.155,364.719,58.118,355.788,57.007,348Z",
    style: {
      fill: "#8ebcbb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.239,352.868l-34.478,64.049s-40.012-5.541-90.99-13.909c1.448,8.933-8.741,17.229-30.347,20.63-3.736.587-7.311,1.184-10.762,1.787H424.575V319.069H397.923C397.532,334.215,396.759,350.7,395.239,352.868Z",
    style: {
      fill: "#8ebcbb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.007,348c1.111,7.79,26.148,16.721,61.409,25.514,29.272-.764,50.41-.92,58.561-.806,59.884.844,90.532,16.351,92.794,30.3,50.978,8.368,90.99,13.909,90.99,13.909l34.478-64.049c2.53-1.486,3.191-56.9,3.08-60.037-30.382-17.1-99.283-13.258-141.455,5.812-34.525,13.205-87.715-2.347-129.716,20.427C109.817,325.243,55.058,334.337,57.007,348Z",
    style: {
      fill: "#d6cec2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.771,403.008c-2.262-13.951-32.91-29.458-92.794-30.3-8.151-.114-29.289.042-58.561.806-29.438.769-67.1,2.152-108.089,4.494q-.69,6.1-1.2,12.26c117.071-4.784,194.344,6.183,99.161,21.607-25.77,4.176-46.342,8.815-62.772,13.552H228.662c3.451-.6,7.026-1.2,10.762-1.787C261.03,420.237,271.219,411.941,269.771,403.008Z",
    style: {
      fill: "#f3dfc1"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M773.423,425.425V579.518a207.908,207.908,0,0,0,68.068-154.093Z",
    style: {
      fill: "#fce2ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.355,425.425V620.989a208.434,208.434,0,0,0,68.068-41.471V425.425Z",
    style: {
      fill: "#fbf1e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.287,633.83a207.849,207.849,0,0,0,68.068-12.841V425.425H637.287Z",
    style: {
      fill: "#fce2ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.219,425.425v198.5a208.229,208.229,0,0,0,68.068,9.909V425.425Z",
    style: {
      fill: "#fbf1e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.151,425.425V586.848a207.989,207.989,0,0,0,68.068,37.073v-198.5Z",
    style: {
      fill: "#fce2ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.083,425.425V526.9a145.8,145.8,0,0,1,41.046,33.437,209.767,209.767,0,0,0,27.022,26.512V425.425Z",
    style: {
      fill: "#fbf1e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.015,425.425v83.419A146.917,146.917,0,0,1,433.083,526.9V425.425Z",
    style: {
      fill: "#fbf1e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.947,425.425v83.384h65.489c.861,0,1.72.02,2.579.035V425.425Z",
    style: {
      fill: "#fce2ba"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.879,
    y: 425.425,
    width: 68.068,
    height: 83.383,
    style: {
      fill: "#fbf1e2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.811,
    y: 425.425,
    width: 68.068,
    height: 83.383,
    style: {
      fill: "#fce2ba"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.743,
    y: 425.425,
    width: 68.068,
    height: 83.383,
    style: {
      fill: "#fce2ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.675,425.425V475.9a83.426,83.426,0,0,0,68.068,32.905V425.425Z",
    style: {
      fill: "#fbf1e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.658,425.425h0A83.007,83.007,0,0,0,24.675,475.9V425.425Z",
    style: {
      fill: "#fce2ba"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 756.406,
    width: 93.594,
    height: 105.506,
    style: {
      fill: "#e9e5df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.027,16.407V79.129H798.1V68.919H787.692c-4.643-12.676-9.972-26.429-14.614-39.094C773.078,29.825,791.152,16.407,827.027,16.407Z",
    style: {
      fill: "#b4c6d8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 797.247,
    y: 68.919,
    width: 29.78,
    height: 10.21,
    style: {
      fill: "#74899f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "827.007 57.007 827.007 61.261 784.52 61.261 782.926 57.007 827.007 57.007",
    style: {
      fill: "#3b444f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "827.007 46.055 827.007 50.2 780.432 50.2 778.828 46.055 827.007 46.055",
    style: {
      fill: "#3b444f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "827.007 34.885 827.007 39.139 776.334 39.139 774.73 34.885 827.007 34.885",
    style: {
      fill: "#3b444f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 797.247,
    y: 74.024,
    width: 29.78,
    height: 5.105,
    style: {
      fill: "#3b444f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.827,
    y: 79.129,
    width: 50.2,
    height: 10.21,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 420.32,
    y: 416.917,
    width: 429.68,
    height: 8.509,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.32,
    y: 280.781,
    width: 429.68,
    height: 8.509,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.32,
    y: 140.39,
    width: 293.544,
    height: 8.509,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.32,
    width: 293.544,
    height: 8.509,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.862,
    y: 208.458,
    width: 425.425,
    height: 8.509,
    transform: "translate(637.287 -211.862) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.252,
    y: 208.458,
    width: 425.425,
    height: 8.509,
    transform: "translate(777.678 -352.252) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496.897,
    y: 208.458,
    width: 425.425,
    height: 8.509,
    transform: "translate(922.322 -496.897) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.423,
    y: 348.849,
    width: 144.645,
    height: 8.509,
    transform: "translate(1198.849 -492.643) rotate(90)",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 549.65,
    y: 42.543,
    width: 12.763,
    height: 97.848,
    transform: "translate(1112.062 182.933) rotate(180)",
    style: {
      fill: "#c66f53"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523.273,
    y: 72.322,
    width: 20.42,
    height: 68.068,
    transform: "translate(1066.967 212.713) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.439,
    y: 60.41,
    width: 10.21,
    height: 79.98,
    transform: "translate(1089.089 200.801) rotate(180)",
    style: {
      fill: "#f5cea9"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 569.219,
    y: 200.801,
    width: 14.464,
    height: 79.98,
    style: {
      fill: "#5998c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 590.49,
    y: 212.713,
    width: 20.42,
    height: 68.068,
    style: {
      fill: "#dbe7e9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.982,
    y: 200.801,
    width: 11.061,
    height: 79.98,
    style: {
      fill: "#7cb8dd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 615.09,
    y: 211.597,
    width: 8.509,
    height: 68.068,
    transform: "translate(-25.318 77.31) rotate(-7)",
    style: {
      fill: "#d3b291"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.504,
    y: 226.417,
    width: 5.055,
    height: 53.385,
    transform: "translate(-26.18 78.181) rotate(-7)",
    style: {
      fill: "#f5987e"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 463.714,
    y: 131.882,
    width: 59.56,
    height: 8.509,
    transform: "translate(986.987 272.272) rotate(180)",
    style: {
      fill: "#3b444f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.714,
    y: 124.224,
    width: 59.56,
    height: 7.658,
    transform: "translate(986.987 256.106) rotate(180)",
    style: {
      fill: "#7b9370"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 643.243,
    y: 236.442,
    width: 45.946,
    height: 17.868,
    transform: "translate(1332.432 490.752) rotate(180)",
    style: {
      fill: "#0d2135"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653.453,
    y: 245.896,
    width: 25.526,
    height: 8.509,
    transform: "translate(1332.432 500.3) rotate(180)",
    style: {
      fill: "#697171"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.528,173.574H657.566l-8.981,31.434,8.981,31.434h17.962l8.982-31.434Z",
    style: {
      fill: "#edb665"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "657.566 173.574 648.585 205.008 657.566 236.442 657.582 236.442 675.479 173.574 657.566 173.574",
    style: {
      fill: "#f8c77e"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M825.782,380.533a36.314,36.314,0,0,1-36.314,36.314H761.239a36.308,36.308,0,0,1-26.287-61.359,26.707,26.707,0,0,0,4.291-28.238c-7.771-18.058,5.853-38.754,25.608-38.615h21.006c19.577-.321,33.471,20.792,25.607,38.615a26.671,26.671,0,0,0,4.475,28.442A36.14,36.14,0,0,1,825.782,380.533Z",
    style: {
      fill: "#db8a73"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.613,327.139c-.019.039-.038.088-.057.127.019-.039.029-.088.048-.127Z",
    style: {
      fill: "#b57865"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.334,327.344c-.019-.039-.039-.087-.058-.126h.01C738.305,327.257,738.315,327.305,738.334,327.344Z",
    style: {
      fill: "#b57865"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "783.634 323.323 766.617 323.323 770.02 199.099 780.23 199.099 783.634 323.323",
    style: {
      fill: "#3b444f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.037,329.279A12.338,12.338,0,0,1,774.7,341.617c-16.366-.65-16.361-24.028,0-24.675A12.338,12.338,0,0,1,787.037,329.279Z",
    style: {
      fill: "#0d2135"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 752.152,
    y: 372.673,
    width: 45.946,
    height: 7.656,
    style: {
      fill: "#303a45"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M787.037,142.092l-.05,44.344A14.014,14.014,0,0,0,780.23,199.1H770.02a14.148,14.148,0,0,0-6.807-12.688l.048-44.319Z",
    style: {
      fill: "#db8a73"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M780.764,151.451a2.888,2.888,0,0,0-3.086,2.87v26.593a2.98,2.98,0,0,0,5.956,0V154.321A2.87,2.87,0,0,0,780.764,151.451Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 787.037,
    y: 173.574,
    width: 3.403,
    height: 5.105,
    rx: 1.17,
    transform: "translate(1577.477 352.254) rotate(-180)",
    style: {
      fill: "#0d2135"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 777.678,
    y: 174.425,
    width: 5.956,
    height: 2.552,
    transform: "matrix(-1, 0, 0, -1, 1561.305, 351.431)",
    style: {
      fill: "#3b444f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 787.037,
    y: 165.065,
    width: 3.403,
    height: 5.105,
    rx: 1.17,
    transform: "translate(1577.477 335.237) rotate(-180)",
    style: {
      fill: "#0d2135"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 777.678,
    y: 165.916,
    width: 5.956,
    height: 2.552,
    transform: "matrix(-1, 0, 0, -1, 1561.305, 334.414)",
    style: {
      fill: "#3b444f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 787.037,
    y: 156.557,
    width: 3.403,
    height: 5.105,
    rx: 1.17,
    transform: "translate(1577.477 318.219) rotate(-180)",
    style: {
      fill: "#0d2135"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 777.678,
    y: 157.408,
    width: 5.956,
    height: 2.552,
    transform: "matrix(-1, 0, 0, -1, 1561.305, 317.397)",
    style: {
      fill: "#3b444f"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M769.486,151.451a2.89,2.89,0,0,1,3.087,2.87v26.593a2.979,2.979,0,0,1-5.955,0V154.321A2.87,2.87,0,0,1,769.486,151.451Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 759.81,
    y: 173.574,
    width: 3.403,
    height: 5.105,
    rx: 1.17,
    style: {
      fill: "#0d2135"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 766.617,
    y: 174.425,
    width: 5.956,
    height: 2.552,
    style: {
      fill: "#3b444f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 759.81,
    y: 165.065,
    width: 3.403,
    height: 5.105,
    rx: 1.17,
    style: {
      fill: "#0d2135"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 766.617,
    y: 165.916,
    width: 5.956,
    height: 2.552,
    style: {
      fill: "#3b444f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 759.81,
    y: 156.557,
    width: 3.403,
    height: 5.105,
    rx: 1.17,
    style: {
      fill: "#0d2135"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 766.617,
    y: 157.408,
    width: 5.956,
    height: 2.552,
    style: {
      fill: "#3b444f"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 770.871,
    y: 199.099,
    width: 0.851,
    height: 173.574,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.423,
    y: 199.099,
    width: 0.851,
    height: 173.574,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775.976,
    y: 199.099,
    width: 0.851,
    height: 173.574,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 778.529,
    y: 199.099,
    width: 0.851,
    height: 173.574,
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 471.371,
    y: 192.292,
    width: 29.78,
    height: 88.488,
    style: {
      fill: "#a8baac"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M492.643,255.681a6.381,6.381,0,0,1-6.382,6.381c-8.447-.292-8.445-12.472,0-12.763A6.382,6.382,0,0,1,492.643,255.681Z",
    style: {
      fill: "#6e6558"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.261,251.426a4.255,4.255,0,0,1,0,8.509,4.255,4.255,0,0,1,0-8.509m0-2.127a6.381,6.381,0,0,0-6.381,6.382c.292,8.447,12.472,8.445,12.763,0a6.382,6.382,0,0,0-6.382-6.382Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 501.151,
    y: 192.292,
    width: 29.78,
    height: 88.488,
    style: {
      fill: "#7b9370"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M522.422,255.681a6.381,6.381,0,0,1-6.381,6.381c-8.447-.292-8.445-12.472,0-12.763A6.381,6.381,0,0,1,522.422,255.681Z",
    style: {
      fill: "#6e6558"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.041,251.426a4.255,4.255,0,0,1,0,8.509,4.255,4.255,0,0,1,0-8.509m0-2.127a6.381,6.381,0,0,0-6.381,6.382c.291,8.447,12.472,8.445,12.762,0a6.381,6.381,0,0,0-6.381-6.382Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 530.931,
    y: 192.292,
    width: 29.78,
    height: 88.488,
    style: {
      fill: "#124a53"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M552.2,255.681a6.381,6.381,0,0,1-6.381,6.381c-8.448-.292-8.445-12.472,0-12.763A6.381,6.381,0,0,1,552.2,255.681Z",
    style: {
      fill: "#6e6558"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.821,251.426a4.255,4.255,0,0,1,0,8.509,4.255,4.255,0,0,1,0-8.509m0-2.127a6.382,6.382,0,0,0-6.382,6.382c.292,8.447,12.473,8.445,12.763,0a6.381,6.381,0,0,0-6.381-6.382Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 713.864,
    y: 200.801,
    width: 14.464,
    height: 79.98,
    style: {
      fill: "#7b9370"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 688.338,
    y: 353.954,
    width: 8.509,
    height: 62.963,
    style: {
      fill: "#f8c77e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 677.291,
    y: 353.713,
    width: 8.509,
    height: 62.963,
    transform: "translate(33.476 -53.992) rotate(4.651)",
    style: {
      fill: "#d6cec2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.216,
    y: 370.971,
    width: 8.509,
    height: 45.946,
    style: {
      fill: "#f5987e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 696.847,
    y: 353.954,
    width: 8.509,
    height: 62.963,
    style: {
      fill: "#5998c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 727.477,
    y: 200.801,
    width: 14.464,
    height: 79.98,
    style: {
      fill: "#424435"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 428.829,
    y: 298.649,
    width: 118.268,
    height: 118.268,
    style: {
      fill: "#a59384"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.635,359.41v4.34a5.425,5.425,0,1,1-10.85,0v-4.34h-21.7v54.252h54.251V359.41Z",
    style: {
      fill: "#f5cea9",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.684,359.41v4.34a5.425,5.425,0,1,1-10.85,0v-4.34h-21.7v54.252h54.252V359.41Z",
    style: {
      fill: "#f5cea9",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.388,301.9v4.34a5.425,5.425,0,1,1-10.85,0V301.9H432.084v54.251h112.3V301.9Z",
    style: {
      fill: "#f5cea9",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "645.93 343.058 576.103 342.792 589.655 292.463 632.761 292.627 645.93 343.058",
    style: {
      fill: "#fce2ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.986,388.839,592.7,388.7c-12.614-28.117,13.22-32.129,15.133-45.79l6.361.024C616.011,356.61,641.814,360.82,628.986,388.839Z",
    style: {
      fill: "#e16745"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "648.425 388.839 569.219 388.839 569.219 416.917 648.425 416.917 648.425 388.839 648.425 388.839",
    style: {
      fill: "#a59384",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.556,392.24A10.643,10.643,0,0,1,595.2,402.877c-.576,14.113-20.7,14.113-21.276,0A10.642,10.642,0,0,1,584.556,392.24Z",
    style: {
      fill: "#edf3f4",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.388,402.877a.958.958,0,0,0-.952-.952h-3.172a.952.952,0,0,0,0,1.9h3.172a.955.955,0,0,0,.952-.952Z",
    style: {
      fill: "#0d2135",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.216,412.172a10.643,10.643,0,0,1-4.124-14.468c7.365-12.053,24.948-2.264,18.591,10.345a10.644,10.644,0,0,1-14.467,4.123Z",
    style: {
      fill: "#edf3f4",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.029,404.9a.958.958,0,0,0,.368,1.294l2.773,1.543a.951.951,0,1,0,.925-1.663c-.791-.442-1.979-1.1-2.771-1.544a.959.959,0,0,0-1.295.37Z",
    style: {
      fill: "#0d2135",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.908,399.5a10.641,10.641,0,0,1-6.706,13.466c-13.564,3.939-19.956-15.144-6.76-20.172a10.641,10.641,0,0,1,13.466,6.706Z",
    style: {
      fill: "#edf3f4",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.5,398.927a.959.959,0,0,0,.6-1.206c-.288-.86-.721-2.147-1.008-3.008a.952.952,0,1,0-1.805.606l1.007,3.007a.961.961,0,0,0,1.206.6Z",
    style: {
      fill: "#0d2135",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M466.084,112.312h33.547A2.371,2.371,0,0,1,502,114.683v9.541a0,0,0,0,1,0,0H463.714a0,0,0,0,1,0,0v-9.541A2.371,2.371,0,0,1,466.084,112.312Z",
    style: {
      fill: "#9db3c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.385,94.517a1.275,1.275,0,0,0-1.805,0C473.905,126.427,426.5,78.978,458.4,44.335a1.276,1.276,0,0,0-1.805-1.8c-23.534,23.394-7.149,64.086,25.676,64.885v5.262h2.971V107.4a37.887,37.887,0,0,0,25.144-11.082A1.274,1.274,0,0,0,510.385,94.517Z",
    style: {
      fill: "#9db3c8"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M517.317,69.4A33.562,33.562,0,0,0,483.755,35.84c-44.52,1.768-44.507,65.364,0,67.125A33.563,33.563,0,0,0,517.317,69.4Z",
    style: {
      fill: "#7b9370"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.76,53.045c1.959-2.039,3.913-4.328,6.624-5.13s6.331.826,6.324,3.654a6.933,6.933,0,0,1-1.55,3.664A141.084,141.084,0,0,0,458.606,76.05c-.921,2.05-1.659,4.8.043,6.266,3.353,2.611,7.305-2.673,10.841-1.467a4.88,4.88,0,0,1,2.812,3.394c.434,1.464.486,3.014.816,4.505,1.426,6.452,8.752,10.932,15.145,9.261a25.894,25.894,0,0,1,4.2-1.108c2.133-.3,4.6,1.358,3.84,3.631a33.537,33.537,0,0,0,8.839-5.26c-1.516-2.437-2-5.623-.2-7.764,1.939-2.313,4.718-2.489,6.429-4.975,3.385-4.92,2.416-8.393,0-9.36-4.254-1.7-23.658,6.641-23.823-1.7-.032-1.583,3.315-3.749,3.092-5.318-.239-1.689-4.385-3.686-7.3-4.035a5.085,5.085,0,0,1-4.586-4.615c-.376-6.294,11.869-4.667,16.7-9.317,3.594-3.457,8.62-3.527,12.932-1.585C491.248,27.739,459.269,35,451.789,59.163A55.318,55.318,0,0,0,458.76,53.045Z",
    style: {
      fill: "#e8f3ff"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 643.243,
    y: 254.404,
    width: 45.946,
    height: 26.376,
    style: {
      fill: "#f5cea9"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M584.535,125.161c.223,5.6,1.681,9.6,5.007,15.261h68.366c3.74-.1,3.733-5.221-.017-5.127H651.91s.367-4.64-4.128-8.98l6.759-2.743c2.282-1.332,1.786-4.452,1.786-4.452s-2.52-.248-2.58-3.563c0,0,.94-4.211-1.726-6.169l-.991-.7c-2.792-2-2.876-4.477-3.713-7.921-4.7,2.029-3.631,5.127-8.951,7.4-4.575,1.957-7.092,9.741-12.4,10.434s-11.988-3.572-16.252-3.572c-3.2,0-6.75-.436-15.1,3.956a28.77,28.77,0,0,1,5.066-6.374c2.869-2.82,6.457-5.609,7.469-9.895,2.252-8.446-5.973-16.419-14.27-13.689A10.95,10.95,0,0,0,586.2,95.05a2.3,2.3,0,0,0,4.144,1.973,6.043,6.043,0,0,1,3.956-3.118c4.184-1.123,8.245,3.073,6.81,7.135-1.045,2.808-3.963,4.388-6.186,6.451C589.869,111.591,584.678,118.8,584.535,125.161Z",
    style: {
      fill: "#b5776d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.365,133.158a6.382,6.382,0,0,0,6.382,6.382c8.447-.292,8.445-12.473,0-12.763A6.381,6.381,0,0,0,665.365,133.158Z",
    style: {
      fill: "#f5987e"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M188.867,183.776c.673-15.75-14.594-28.053-29.8-24.327a9.546,9.546,0,0,1-9.7-3.363,35.13,35.13,0,0,0-27.756-13.549c-6.12.265-13.174,2.4-17.536-3.29a39.619,39.619,0,0,0-66.527,9.259,14.124,14.124,0,0,1-13.078,8.4A24.281,24.281,0,0,0,.162,183.784h188.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.665,144.64a14.806,14.806,0,0,1,18.12-14.808,5.8,5.8,0,0,0,5.9-2.047,21.354,21.354,0,0,1,16.878-8.247c3.722.161,8.011,1.462,10.664-2a24.081,24.081,0,0,1,40.455,5.636,8.588,8.588,0,0,0,7.953,5.111,14.774,14.774,0,0,1,14.784,16.363H201.669Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.765,225.474c-.261-3.653,5.654-6.5,11.543-5.641a5.282,5.282,0,0,0,3.758-.78,18.03,18.03,0,0,1,10.752-3.142c2.371.061,5.1.557,6.794-.763a20.641,20.641,0,0,1,11.763-3.286c6.246,0,11.619,2.232,14.008,5.433.9,1.2,2.866,1.957,5.066,1.947,5.584-.05,10.067,2.922,9.418,6.233h-73.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "185.474 579.6 216.184 579.6 216.184 624.588 180.806 624.588 185.474 579.6",
    style: {
      fill: "#61382d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.083,655.3h73.7a12.284,12.284,0,0,0,12.284-12.284H123.8A12.284,12.284,0,0,0,136.083,655.3Z",
    style: {
      fill: "#d7a38f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.07,643.014H123.8s-.372-7.337,13.613-10.662c16.308-3.854,38.936-10.275,45.375-27.853,7.622.727,13.442,6.567,14.971,13.947h18.426Z",
    style: {
      fill: "#f5cea9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.066,625.447c-2.151-9.795-16.707-11.035-17.955-11.233-.83-.347-9.726-4.542-16.576-2.742-10.107,3.058-8.259,13.212,1.683,13.673,6.335,0,12.368-5.9,14.331-8.018.57,2.751,2.447,10.21,6.629,13.793C186.526,635.733,194.714,633.839,193.066,625.447ZM157.7,621.571c-4.484-1.725-3.433-5.562,1.67-7.143,3.747-1.061,9.124.525,12.007,1.576C168.227,619.118,162.346,623.538,157.7,621.571Zm31.335,8.563c-1.2.7-3.6.387-5.858-1.546-2.967-2.541-4.618-7.887-5.342-10.869,4.338.895,11.276,3.34,12.214,8.3C190.273,627.206,190.44,629.32,189.034,630.134Z",
    style: {
      fill: "#d7a38f"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "131.088 516.637 160.641 524.986 148.41 568.28 114.364 558.661 131.088 516.637",
    style: {
      fill: "#61382d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.976,576.055,133.9,596.093a12.284,12.284,0,0,0,15.161-8.481L54.5,560.894A12.283,12.283,0,0,0,62.976,576.055Z",
    style: {
      fill: "#d7a38f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.065,587.612,54.5,560.894s1.637-7.162,16-6.558c16.741.724,40.263.7,51.239-14.469,7.136,2.773,11.149,9.975,10.615,17.492l17.732,5.01Z",
    style: {
      fill: "#f5cea9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.871,547.21c.712-2.777-10.883-7.749-14.178-8.232-7.453-1.738-16.436,7.285-7.49,12.175a13.89,13.89,0,0,0,3.819,1.369c-4.46,5.179-3.206,15.28,5.479,12.36C112.066,562.179,116.869,552.534,116.871,547.21Zm-22.14-1.986c.841-2.023,4.281-3.922,7.291-3.248a35.155,35.155,0,0,1,9.748,4.029,43.072,43.072,0,0,0-9.221,3.81,12.114,12.114,0,0,1-6.5-1.721C94.065,546.823,94.566,545.62,94.731,545.224Zm8.115,16.932c-5.232,1.38-3.488-6.8-.413-8.595.357-.248.728-.485,1.1-.717a26.957,26.957,0,0,0,9.7-2.391C111.942,554.27,108.508,560.668,102.846,562.156Z",
    style: {
      fill: "#d7a38f"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M391.071,420.542c-12.142,54.987-37.259,63.309-62.614,64.159l-83-.487a13.94,13.94,0,0,0-14.015,13.514l-9.37,95.165H169.745l5.2-138.353c-1.732-25.972,2.428-70.424,2.428-70.424Z",
    style: {
      fill: "#424435",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.288,393.654,128.8,520.108l43.711,17,7.918-96.985a13.382,13.382,0,0,1,20.475-10.232l93.029,58.648,54.584.772c30.42.981,59.009-13.662,68.4-42.613l4.254-45.521-59.134,7.4-155.676-39.62A35.159,35.159,0,0,0,163.288,393.654Z",
    style: {
      fill: "#666850",
      fillRule: "evenodd"
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "393.535 257.978 327.168 316.687 327.791 361.672 411.403 332.002 393.535 257.978",
    style: {
      fill: "#102325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.5,374.831a36.763,36.763,0,0,1,1.765-13.585l25.792-79.77c2.589-8.74-.313-16.313.863-25.595l1.955-16.539c.538-3.753,5.072-5.39,6.44-2.127-.623-6.059,4.747-8.422,7.014-5.062.957-5.316,7.5-5.187,8.307-.466.982-4.745,7.392-4.644,7.691-.291l.513,7.28a4.917,4.917,0,0,1,4.11-2.215,2.334,2.334,0,0,1,1.928,3.36,49.884,49.884,0,0,0-3.314,8.413l-1.806,11.134-6.966,10.608a18.135,18.135,0,0,0-2.907,8.373l-8.5,97.046Z",
    style: {
      fill: "#553129"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M427.978,211.862c-.3-4.15,2.221-13.127,2.283-13.262h-.005s3.266-10.22,3.266-15.852a40.055,40.055,0,0,0-78.805-10.135l-4.239,1.175,3.14,12.955h0c.094.957.232,1.9.392,2.835h-.007c1.088,10.053-.484,15.791-1.162,17.721s-1.424,4.62,1.684,6.215a4.739,4.739,0,0,1,2.6,3.025l3.532,10.247c2.347,7.221,6.3,10.582,13.689,8.905,6.708-1.534,11.675-2.562,13.861-3.026a35.214,35.214,0,0,1-1.923,16.522l44.8-15.62C429.606,230.733,428.829,222.278,427.978,211.862Z",
    style: {
      fill: "#61382d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.48,173.785c4.371-1.22,10.427-2.922,14.852-3.964l2.616,7.072c3.288-.366,6.49-.852,9.543.723a10.686,10.686,0,0,1,5.316,6.423l2.742,9.271c2.9,7.726-3.128,21.506-11.175,21.955H356.507l4.153,11.519c2.347,7.221,5.471,11.429,12.864,9.753l18.718-4.255c4.971-1.118,6.439-6.993,5.1-11.912-2.186-7.223-4.5-14.205-6.431-21.519-.684-2.479-1.7-5.206-1.784-7.791a9.113,9.113,0,0,1,18.185-1.1l.037-.007c.519,2.575,1.576,7.957,2.087,10.492,1.872,8.968,12.547,11.231,19.388,11.208.019-.161,2.468-10.022,4.747-12.107,2.01-1.839,2.384-4.6,2.559-7.176a16.806,16.806,0,0,1,1.882-8.228,7.7,7.7,0,0,0-.069-6.32,13.989,13.989,0,0,1-1.382-8.37,7.7,7.7,0,0,0-2.121-6.415,13.93,13.93,0,0,1-3.523-6.754,7.834,7.834,0,0,0-5.328-5.441,7.7,7.7,0,0,1-4.216-3.816A7.7,7.7,0,0,0,416,142.881c-2.585-.525-4.564-1.171-6.472-3.081a7.7,7.7,0,0,0-6.463-1.912,18.927,18.927,0,0,1-4.964.5,17.717,17.717,0,0,1-4.792-1.613,7.7,7.7,0,0,0-6.248.184c-1.793.861-3.617,2.062-5.625,2.312-4.006.42-8.373-1.457-11.62,1.893-1.553,1.421-3.738,3.953-5.886,4.439l-4.452,1.333a7.7,7.7,0,0,0-4.9,4.423l-1.745,4.2c-1.31,3.123-5.42,5.028-6,8.607C346.382,167.3,349.728,170.529,350.48,173.785Z",
    style: {
      fill: "#102325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.842,190.307a1.131,1.131,0,0,0-1.38-.815l-24.257,6.249-1.954-7.323a1.134,1.134,0,0,0-2.19.585l4.487,16.816a1.134,1.134,0,0,0,2.191-.585l-1.949-7.3,24.237-6.244A1.133,1.133,0,0,0,385.842,190.307Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370.562,266.486c-20.536,47.917-52.769,122.523-52.769,122.523,46.371,18.549,80.831,73,80.831,73l13.613,2.127c23.067-22.286,32.534-62.7,35.736-93.168l8.083-62.112c3.4-43.394-24.967-75.294-24.967-75.294L388.43,246.917C382.971,248.82,375.667,254.575,370.562,266.486Z",
    style: {
      fill: "#124a53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.947,377l-66.941-21.8c-9.3-3.022-15.175-10.837-15.175-10.837l-9.08-9.375a12.431,12.431,0,0,0-12.1-3.37l-28.459,7.522c-5.715,1.244-2.565,5.574.67,5.471-3.1,1.2.6,5.393,6.753,3.293-2.594,2.344,2.083,4.247,7.108,2.6-2.044,2.219.9,4.378,6.576,2.626,2.626-.538,4.231,2.045,4.231,2.045l4.427,6.841c3.47,5.525,8.733,4.633,13.07,6.442s10.934,8.764,15.887,11.817l56.819,35.347a37.858,37.858,0,0,0,50.4-9.585Z",
    style: {
      fill: "#61382d"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M487.354,332.766,447.983,545.594l-44.22-44.221c6.449-60.069,27.165-123.6,63.62-174.313l3.2-1.422A12.461,12.461,0,0,1,487.354,332.766Z",
    style: {
      fill: "#dbe7e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.917,545.4H448.858l-44.22-44.9-2.806-.822A410.1,410.1,0,0,0,287.837,483.3c-37.827-.136-48.95,0-48.95,0-6.859,0-11.71,3.389-11.71,15.347v35.689C228.028,541.992,232.046,545.412,238.917,545.4Z",
    style: {
      fill: "#bfd3d6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.011,
    y: 429.215,
    width: 99.895,
    height: 17.688,
    rx: 4.422,
    transform: "translate(561.78 928.248) rotate(-169.397)",
    style: {
      fill: "#dbe7e9"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M503.56,644.69a9.325,9.325,0,0,1-8.316-5.068l-47.17-91.476a5.394,5.394,0,0,1-.523-3.5L470.993,419.46c1.092-5.894,9.76-5.809,10.628.212l31.2,214.314A9.416,9.416,0,0,1,503.56,644.69ZM476.281,419.318a1.045,1.045,0,0,0-1.107.925c.132.879-23.958,125.2-23.329,125.933l47.18,91.5a5.1,5.1,0,0,0,9.584-3.073l-31.2-214.314v0A1.052,1.052,0,0,0,476.281,419.318Z",
    style: {
      fill: "#124a53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.9,646.392a2.134,2.134,0,0,1-2.118-2.347l18.379-177c-.409-19.9,19.763-29.5,38.08-25.43l163.846,29.813a2.127,2.127,0,0,1-.761,4.186L297.436,445.788a35.162,35.162,0,0,0-15.057.015c-11.584,2.683-17.963,10.265-17.963,21.35-.161.111-18.265,177.178-18.4,177.331A2.127,2.127,0,0,1,243.9,646.392Z",
    style: {
      fill: "#124a53"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.624,
    y: 449.875,
    width: 4.254,
    height: 194.995,
    transform: "translate(-195.29 899.083) rotate(-89.891)",
    style: {
      fill: "#124a53"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M105.555,259.643h-4.706a2.132,2.132,0,0,0-2.022,2.81L137.14,376.8H251.868a10.183,10.183,0,0,0-10.183-10.182H145.119l-34.33-103.209A5.518,5.518,0,0,0,105.555,259.643Z",
    style: {
      fill: "#0d2135",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M794.638,523.273a4.936,4.936,0,0,1,5.162,4.673v26.39a4.936,4.936,0,0,1-5.162,4.673H656.006V523.273Z",
    style: {
      fill: "#a0b4b7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.252,527.528H795.546a0,0,0,0,1,0,0v27.227a0,0,0,0,1,0,0H660.252a4.246,4.246,0,0,1-4.246-4.246V531.774A4.246,4.246,0,0,1,660.252,527.528Z",
    transform: "translate(1451.552 1082.282) rotate(180)",
    style: {
      fill: "#fdfaf5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M745.568,534.334c2.227,0,4.032,1.445,4.032,3.227v18.221c0,1.782-1.805,3.227-4.032,3.227H637.287V534.334Z",
    style: {
      fill: "#666850",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.5,536.887H747.047a0,0,0,0,1,0,0v19.57a0,0,0,0,1,0,0H640.5a3.213,3.213,0,0,1-3.213-3.213V540.1A3.213,3.213,0,0,1,640.5,536.887Z",
    transform: "translate(1384.334 1093.343) rotate(180)",
    style: {
      fill: "#fdfaf5"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 679.83,
    y: 496.046,
    width: 114.014,
    height: 27.227,
    rx: 3.403,
    style: {
      fill: "#0d2135"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.389,
    y: 499.449,
    width: 20.42,
    height: 20.42,
    style: {
      fill: "#b1c585"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "766.617 519.87 778.529 499.449 790.44 519.87 766.617 519.87",
    style: {
      fill: "#f4b7a8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.881,509.66a10.21,10.21,0,0,1-10.21,10.21c-13.544-.538-13.54-19.885,0-20.421A10.211,10.211,0,0,1,730.881,509.66Z",
    style: {
      fill: "#f8c77e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.85,509.66l7.3-7.306a1.7,1.7,0,1,0-2.406-2.406l-7.306,7.305-7.3-7.305a1.7,1.7,0,1,0-2.406,2.406l7.305,7.306-7.305,7.305a1.7,1.7,0,1,0,2.406,2.406l7.3-7.3,7.306,7.3a1.7,1.7,0,0,0,2.406-2.406Z",
    style: {
      fill: "#697171"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M830.43,593.043A34.134,34.134,0,0,0,796.4,559.009H626.226a34.134,34.134,0,0,0-34.034,34.034v8.509H830.43Z",
    style: {
      fill: "#a8baac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.192,601.552v8.508a34.134,34.134,0,0,0,34.034,34.034H796.4A34.134,34.134,0,0,0,830.43,610.06v-8.508Z",
    style: {
      fill: "#fce2ba"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanJumbo);
export default __webpack_public_path__ + "static/media/lan-jumbo.5fab134b30015f482420fb159638d24f.svg";
export { ForwardRef as ReactComponent };